import { render, staticRenderFns } from "./metronome.vue?vue&type=template&id=51b8e04c&scoped=true"
import script from "./metronome.vue?vue&type=script&lang=js"
export * from "./metronome.vue?vue&type=script&lang=js"
import style0 from "./metronome.vue?vue&type=style&index=0&id=51b8e04c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51b8e04c",
  null
  
)

export default component.exports